import {
  processingModalPhraseMap,
} from "apps/website/components/form/CardDetails/CardDetailsFormCheckoutV2/CardDetailsFormCheckoutV2.map";
import { TCheckoutBasketType } from "libs/types/checkout/src/primitives";

/**
 * Processing phrases for checkout components
 * These phrases are displayed in the ProcessingPaymentModal during payment processing
 *
 * We import from the existing processingModalPhraseMap to maintain a single source of truth.
 */
export const FRESH_PROCESSING_PHRASES = [
  ...(processingModalPhraseMap.FRESH || []),
];

export const SCOOP_PROCESSING_PHRASES = [
  ...(processingModalPhraseMap.SCOOP || []),
];

/**
 * Default processing phrases for other product types
 * Fallback phrases when product-specific phrases are not available
 */
export const DEFAULT_PROCESSING_PHRASES = [
  "Preparing your order...",
  "Processing payment...",
  "Almost there...",
];

/**
 * Utility function to get the appropriate processing phrases based on basket type
 * @param basketType - The type of checkout basket (FRESH, LITTER, or other)
 * @returns Array of processing phrases to display in the ProcessingPaymentModal
 */
export const getProcessingPhrases = (basketType: TCheckoutBasketType): string[] => {
  switch (basketType) {
    case "FRESH":
      return FRESH_PROCESSING_PHRASES;
    case "LITTER":
      return SCOOP_PROCESSING_PHRASES;
    default:
      return DEFAULT_PROCESSING_PHRASES;
  }
};
